const Row = ({ items }) => (
  <div className="flex shrink-0 items-center">
    {items.map((it, i) => (
      <span
        key={i}
        className="flex items-center gap-8 pr-8 md:gap-12 md:pr-12 whitespace-nowrap"
      >
        <span className="font-display text-2xl md:text-4xl italic text-pine/85">
          {it}
        </span>
        <span className="inline-block h-2 w-2 rotate-45 bg-terracotta" />
      </span>
    ))}
  </div>
);

export default function Marquee({ items, className = "" }) {
  return (
    <div
      className={`marquee-hover relative overflow-hidden border-y border-pine/10 py-6 md:py-8 ${className}`}
      data-testid="editorial-marquee"
    >
      <div className="flex w-max animate-marquee">
        <Row items={items} />
        <div aria-hidden="true">
          <Row items={items} />
        </div>
      </div>
    </div>
  );
}
